import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { RequirePermission } from '@/features/auth/guards';
import { NotFoundPage } from '@/pages/not-found-page';

const ConsignorsList = lazy(() => import('./pages/consignors-list-page').then((m) => ({ default: m.ConsignorsListPage })));
const ConsignorDetail = lazy(() => import('./pages/consignor-detail-page').then((m) => ({ default: m.ConsignorDetailPage })));
const BatchesList = lazy(() => import('./pages/batches-list-page').then((m) => ({ default: m.BatchesListPage })));
const BatchForm = lazy(() => import('./pages/batch-form-page').then((m) => ({ default: m.BatchFormPage })));
const BatchDetail = lazy(() => import('./pages/batch-detail-page').then((m) => ({ default: m.BatchDetailPage })));
const SettlementsList = lazy(() => import('./pages/settlements-pages').then((m) => ({ default: m.SettlementsListPage })));
const SettlementDetail = lazy(() => import('./pages/settlements-pages').then((m) => ({ default: m.SettlementDetailPage })));
const Payouts = lazy(() => import('./pages/payouts-page').then((m) => ({ default: m.PayoutsPage })));
const Overdue = lazy(() => import('./pages/overdue-page').then((m) => ({ default: m.OverduePage })));
const Settings = lazy(() => import('./pages/settings-page').then((m) => ({ default: m.SettingsPage })));

const fallback = (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-12 w-full" />
    ))}
  </div>
);

/** Rotas do módulo de consignação (montadas em `consignacao/*`; a permissão de leitura fica em app/routes.tsx). */
export function ConsignmentsRoutes() {
  return (
    <Suspense fallback={fallback}>
      <Routes>
        <Route index element={<ConsignorsList />} />
        <Route path="consignantes/:id" element={<ConsignorDetail />} />
        <Route path="lotes" element={<BatchesList />} />
        <Route path="lotes/novo" element={<RequirePermission permission="consignments.write" children={<BatchForm />} />} />
        <Route path="lotes/:id" element={<BatchDetail />} />
        <Route path="acertos" element={<SettlementsList />} />
        <Route path="acertos/:id" element={<SettlementDetail />} />
        <Route path="repasses" element={<Payouts />} />
        <Route path="vencidas" element={<Overdue />} />
        <Route path="configuracoes" element={<Settings />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
